export default function BlockIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4224_68816)">
        <path
          d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
          fill="var(--text-secondary-color)"
          fillOpacity="0.4"
        />
        <rect
          x="13"
          y="7"
          width="2"
          height="10"
          transform="rotate(90 13 7)"
          fill="var(--text-secondary-color)"
        />
      </g>
      <defs>
        <clipPath id="clip0_4224_68816">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
